export default "__VITE_ASSET__BZllphn$__"